import pb from "../pocketbase";

const POCKETBASE_URL = process.env.REACT_APP_POCKETBASE_URL;

/** Call PocketBase Telegram Login endpoint */
async function callTgLogin(body) {
  const response = await fetch(`${POCKETBASE_URL}/api/custom/tg-login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Telegram login failed');
  }

  if (!data.token) {
    throw new Error('No token in response');
  }

  return data;
}

/** Login via Telegram Login Widget.
 * `user` is the object from widget onauth callback. We send ONLY non-empty fields.
 */
export async function loginWithTelegramWidget(user) {
  const out = {};
  const copy = (k) => {
    const v = user?.[k];
    if (v !== undefined && v !== null && String(v) !== "") out[k] = String(v);
  };
  // exact keys used by the widget
  copy("id");
  copy("first_name");
  copy("last_name");
  copy("username");
  copy("photo_url");
  copy("auth_date");
  copy("hash"); // MUST be present

  if (!out.hash) throw new Error("Telegram payload has no hash");

  const data = await callTgLogin(out);

  // Save auth token to PocketBase authStore
  pb.authStore.save(data.token, data.user);

  // Reload page to apply auth
  window.location.reload();
}

/** Login via Telegram WebApp.
 * `initData` MUST be the exact string from window.Telegram.WebApp.initData.
 * Do NOT parse or rebuild `user` here; send the raw string to preserve signature.
 */
export async function loginWithTelegramWebApp(initData) {
  if (!initData) throw new Error("Telegram WebApp initData is missing");

  const data = await callTgLogin({ init_data: initData });

  // Save auth token to PocketBase authStore
  pb.authStore.save(data.token, data.user);

  // Reload page to apply auth
  window.location.reload();
}
